import { useWizard } from "../../hooks/useWizard";
import { Info } from "./Steps/info";
import { MetricSelector } from "./Steps/metric";
import { RegionSelector } from "./Steps/region";
import { YearSelector } from "./Steps/year";

export const Stepper = () => {
  const { step } = useWizard();

  switch (step) {
    case 1:
      return <Info />;
    case 2:
      return <YearSelector />;
    case 3:
      return <RegionSelector />;
    case 4:
      return <MetricSelector />;
    default:
      return null;
  }
};